<div class="cpd-entry">
  <div class="header-container">
    <h4 class="entry-title">{{cpdEntry.title}}</h4>
    <div class="entry-type">{{type?.title}}</div>
  </div>
  @if (annotationsVisible) {
    <app-cpd-entry-annotations [cpdEntry]="cpdEntry"></app-cpd-entry-annotations>
  }
  <app-cpd-entry-answers [cpdEntry]="cpdEntry"></app-cpd-entry-answers>
</div>
